<template>
  <el-table
    :data="tableData"
    stripe
    style="width: 100%"
  >
    <el-table-column
      sortable
      width="120"
      prop="type"
      :label="$t('tipo')"
    >
      <template slot-scope="scope">
        {{ scope.row.type === 'include' ? "Permitir" : "Restringir" }}
      </template>
    </el-table-column>
    <el-table-column
      sortable
      prop="source"
      width="200"
      :label="$t('origem')"
    >
      <template slot-scope="scope">
        {{ scope.row.source.state }}
      </template>
    </el-table-column>
    <el-table-column
      sortable
      prop="destiny"
      :label="`${$t('destino')}?`"
    >
      <template slot-scope="scope">
        {{ scope.row.destiny.state && scope.row.destiny.state.length > 0 ?  scope.row.destiny.state.join(', ') : 'Todos' }}
      </template>
    </el-table-column>
    <TableColumnButton @edit="edit" @remove="remove" />
  </el-table>
</template> 
<script>

import { i18n } from "@/plugin/i18n";
import ShippingAddFormRestrictedAdd from "./ShippingAddFormRestrictedAdd.vue";
import TableColumnButton from "./TableColumnButton.vue";

export default {
  name: "ShippingAddFormRestricted",
  props: ['tableData'],
  methods: {
    edit(index, data) {
      this.$emit("edit", index, data);
    },
    remove(index) {
      const vm = this;
      this.$confirm(i18n.t("confirmar-eliminacao-restricoes"), i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        vm.$emit("remove", index);
      });
    },
  },
  components: { ShippingAddFormRestrictedAdd, TableColumnButton }
}
</script>

<style>
.uppercase {
  text-transform: uppercase;
}
</style>